import { FC, useEffect, useMemo } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useCurrentUser } from '@hooks/users';
import { isUserSubscribed } from '@helpers';
import { SubscribeForm } from '../components/SubscribeForm';
import { getEnrolledPlan } from '../lib/getEnrolledPlan';
import { getSubscriptionForDegree } from '../lib/getSubscriptionForDegree';

const COURSE_BUILDER_ROUTE = '/course-builder';

export const SubscribePage: FC = () => {
  const navigate = useNavigate();
  const { data: user } = useCurrentUser();
  const plan = useMemo(() => getEnrolledPlan(user), [user]);
  const subscription = useMemo(
    () => getSubscriptionForDegree(plan?.degreeType),
    [plan?.degreeType]
  );
  const alreadySubscribed = Boolean(user && isUserSubscribed(user));
  const needsPlan = Boolean(user && !alreadySubscribed && !plan);

  useEffect(() => {
    if (alreadySubscribed) {
      navigate({ to: '/' });
    } else if (needsPlan) {
      navigate({ to: COURSE_BUILDER_ROUTE });
    }
  }, [alreadySubscribed, needsPlan, navigate]);

  if (!user || alreadySubscribed || !plan) {
    return null;
  }

  return (
    <div className="flex flex-col gap-8 p-8">
      <SubscribeForm
        subscription={subscription}
        degreeName={plan.degreeName}
        degreeType={plan.degreeType}
      />
    </div>
  );
};
